import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, empty: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    empty: false,
};

class Block extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            empty,
        } = this.props;
        return [
            'c-block',
            empty ? 'c-block_empty' : 'c-block_shadow',
            className,
        ];
    }

}

Block.propTypes = propTypes;

Block.defaultProps = defaultProps;

export default Block;
